import { useUserIdentityState } from '@provider/user-identity';
import { PublisherLogo } from '@ui/kit/icons';
import { ReliefSVG } from './atom.relief-svg.js';
import { footer, relief, content, copyright, pageContext, pageNumber, publisherLogo } from './footer.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function PrintFooter(props) {
  const user = useUserIdentityState(state => state.user);
  const userLabel = (() => {
    const date = new Date().toLocaleDateString("da-DK", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    if (user?.institution?.name && user.name) {
      return `Dette arbejdsark er udskrevet af ${user.name}, ${user.institution.name}, ${date}.`;
    }
    if (user?.name) {
      return `Dette arbejdsark er udskrevet af ${user.name}, ${date}.`;
    }
    return `Dette arbejdsark er udskrevet ${date}.`;
  })();
  return /*#__PURE__*/jsxs("footer", {
    className: footer,
    children: [/*#__PURE__*/jsx(ReliefSVG, {
      className: relief
    }), /*#__PURE__*/jsxs("div", {
      className: content,
      children: [/*#__PURE__*/jsxs("div", {
        className: copyright,
        children: ["Print og kopiering af dette materiale er tilladt, forudsat at det sker i overensstemmelse med skolens aftale med Tekst & Node.", /*#__PURE__*/jsx("br", {}), userLabel]
      }), /*#__PURE__*/jsxs("div", {
        className: pageContext,
        children: [props.context.physical && /*#__PURE__*/jsxs("span", {
          className: pageNumber,
          children: [/*#__PURE__*/jsx("b", {
            children: props.context.physical.currentPageIndexInDocument + 1
          }), "/", props.context.physical.pagesInDocument]
        }), /*#__PURE__*/jsx(PublisherLogo, {
          small: true,
          className: publisherLogo
        })]
      })]
    })]
  });
}

export { PrintFooter };
//# sourceMappingURL=footer.js.map
